<template>
  <div class="p-tasklist-form--checked">
    <p class="p-tasklist-form--checked__count">
      選択数 : <span class="c-text--bold">{{ count }}</span>
    </p>
    <slot name="csv"></slot>
    <p class="p-tasklist-form--checked__guide">
      <slot>選択した項目を</slot>
    </p>
    <div class="p-tasklist-form--checked__btn">
      <div class="c-alertPos">
        <Button
          variant="main"
          fsize="f12"
          icon="plus"
          :class="{
            'is-loading': isProcessing,
            'is-inactive': isInactive
          }"
          :disabled="isProcessing"
          @click="submit"
        >
          タスクに登録する
        </Button>
        <Alert v-if="errorResponses.length">
          {{ errorResponses[0] }}
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import { USAGE_LABEL } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Alert,
    Button
  },
  data() {
    return {
      errorResponses: [],
      usages: {
        rest: 0
      },
      isOver: false,
      isProcessing: false
    };
  },
  computed: {
    count() {
      return this.checked.length;
    },
    isInactive() {
      return this.count ? false : true;
    },
    isCompetitiveSiteKeyword() {
      return this.$route.name === 'competitiveSiteKeywordResult';
    }
  },
  watch: {
    checked: {
      handler() {
        this.resetError();
      }
    }
  },
  methods: {
    submit() {
      if (this.isInactive || this.isProcessing) {
        return;
      }
      this.isProcessing = true;
      this.resetError();

      // 利用量を取得
      this.getUsages()
        .then(response => {
          if (this.$route.name == 'competitiveKeywordSuggestAnalysis') {
            this.$emit('pushAmplitudeEvent');
          }
          Promise.all(
            this.checked.map(item => {
              return this.postTask(item).then(() => {
                this.$emit('submit', item);
              });
            })
          ).finally(() => {
            this.$store.dispatch('project/getTaskCount');
            this.isProcessing = false;
          });
        })
        .catch(error => {
          this.isProcessing = false;
        });
    },
    getUsages() {
      const params = {
        items: 'tasks'
      };
      return apiProjects.usages
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          const usages = response.data.items[0]; //登録数
          const usagesRest = usages.max - usages.current;
          if (usagesRest <= 0) {
            this.errorResponses.push(
              `${USAGE_LABEL['tasks']}の上限を超えています。登録するにはタスクを削除してください`
            );
          } else if (usagesRest < this.count) {
            this.errorResponses.push(
              `${USAGE_LABEL['tasks']}の上限を超えています。登録できるのは${usagesRest}件までです`
            );
            this.usages.rest = usagesRest;
            this.isOver = true;
          }
          if (this.errorResponses.length) {
            return Promise.reject();
          }
        })
        .catch(error => {
          if (error.response) {
            this.errorResponses = [error.response.data.errors[0].userMessage];
          }
          throw error;
        });
    },
    postTask(item) {
      const params = {
        column: 'todo',
        keyword: null,
        operatorUserId: null,
        taskDetail: '',
        type: this.type,
        url: null
      };

      if (this.type === 'createContent') {
        params.keyword = item.keyword;
        params.taskDetail =
          '新規でコンテンツを作成する\n「' +
          item.keyword +
          '」のキーワードで新規コンテンツを作成する';
      } else if (this.type === 'seoCheckUp') {
        // 最後のスラッシュ抜きのサイトURL
        const projectUrl = this.$options.filters.removeTrailingSlash(
          this.project.siteUrl
        );
        // 2021/9 インシデント#18705の対応で追加
        // サイトURLの末尾のスラッシュが抜けた状態でタスク登録するとタスクモーダル上でURLが正しく表示できないため、サイトURLには強制的にスラッシュをつける対応。
        // SEO課題チェックでは自サイトに登録されたURL以外で調査された場合はそもそもタスク登録ができないので他ドメインへの対応は不要
        let url = item.url;
        if (url == projectUrl) {
          url = this.$options.filters.addTrailingSlash(url);
        }

        params.taskDetail = utils.getProposalTaskDetail({
          content: item.id,
          type: this.type,
          url: url
        });
        params.url = url;
      }

      return apiProjects.tasks.siteAnalysis
        .post(params, this.auth.idToken, this.project.id)
        .catch(error => {
          if (error.response) {
            this.errorResponses.push(error.response.data.errors[0].userMessage);
          }
          throw error;
        });
    },
    resetError() {
      if (!this.isOver || this.usages.rest >= this.count) {
        this.errorResponses = [];
        this.isOver = false;
      }
    }
  }
};
</script>
